import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";
import { useToast } from "vue-toastification";
import { MarcaProductoUpdateParams } from "../../interfaces/marcaProductosInterfaces/MarcaProductoUpdateParams";
import { UpdateMarcaProductoAction } from "../../actions/marcaActions";

const toast = useToast();

export function useMarcaProductoUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idMarca, formData }: MarcaProductoUpdateParams) =>
      UpdateMarcaProductoAction(idMarca, formData),

    onSuccess: async (
      response: ApiResponse<MarcaProductoInterface>,
      variables
    ) => {
      // Eliminar cachÃ© del detalle (find one)
      queryClient.removeQueries({
        queryKey: ["MarcaProductoFindOne", variables.idMarca],
      });

      // Refrescar la lista completa
      await queryClient.invalidateQueries({
        queryKey: ["MarcaProductosList"],
      });

      toast.success("Marca de producto actualizada correctamente");

      if (onClose) onClose();
    },

    // Error
    onError: (error: unknown) => {
      toast.error("Error al actualizar marca de producto");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation,
  };
}
